import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { Address, ExecutionResult } from "@tylertech/tyler-api-types";

@Injectable()
export class ContactManagerService
{
    constructor(
        private readonly $apiService: ApiService)
    { }

    getAccountSmartCardInfoByContactId(contactId: string): Promise<UBAccountSmartCardInfo[]>
    {
        return this.$apiService.sendAuth<string, ExecutionResult<UBAccountSmartCardInfo[]>>("IContactManagerService/GetAccountSmartCardInfoByContactId", contactId)
            .then(ContactManagerService.stripOutOfExecutionResult);
    }

    getEnergovSmartCardInfoByContactId(contactId: string): Promise<EnergovSmartCardInfo[]>
    {
        return this.$apiService.sendAuth<string, ExecutionResult<EnergovSmartCardInfo[]>>("IContactManagerService/GetEnergovSmartCardInfoByContactId", contactId)
            .then(ContactManagerService.stripOutOfExecutionResult);
    }

    getLicenseSmartCardInfoByContactId(pContactId: string): Promise<LicenseSmartCardInfo[]>
    {
        return this.$apiService.sendAuth("IContactManagerService/GetLicenseSmartCardInfoByContactId", pContactId);
    }

    getPermitSmartCardInfoByContactId(pContactId: string): Promise<PermitSmartCardInfo[]>
    {
        return this.$apiService.sendAuth("IContactManagerService/GetPermitSmartCardInfoByContactId", pContactId);
    }

    getPropertyTaxSmartCardInfoByContactId(contactId: string): Promise<PTSmartCardInfo[]>
    {
        return this.$apiService.sendAuth("IContactManagerService/GetPropertyTaxSmartCardInfoByContactId", contactId);
    }

    private static stripOutOfExecutionResult<T>(x: ExecutionResult<T>): T
    {
        return x ? x.Result : null;
    }
}
export interface COSmartCardItem
{
    Id: string;
    ModuleAbbreviation: string;
    Balance: number;
    Selected: boolean;
    DisplayName: string;
}
export interface UBAccountSmartCardInfo extends COSmartCardItem
{
    FormattedAccountNumber: string;
    StatusDescription: string;
    ParcelId: string;
    ParcelNumber: string;
    ServiceAddressId: string;
    ServiceAddressNumber: string;
    SiteFullAddress: string;
    StatusBanner: string;
    IsLandlord: boolean;
    IsAdditionalContact: boolean;
    IsDisplayCollections: boolean;
}
export interface EnergovSmartCardInfo extends COSmartCardItem
{
    InvoiceNumber: string;
    Status: string;
    AdditionalInfo: string;
}
export interface PTSmartCardInfo extends COSmartCardItem
{
    ParcelNumber: string;
    BillNumber: string;
    DueDate: string;
}
export interface LicenseSmartCardInfo extends COSmartCardItem
{
    LicenseNumber: string;
    LicenseCode: string;
    IssuedTo: string;
    Status: string;
    ExpirationDate: string;
    ExpirationDateShort: string;
}
export interface PermitSmartCardInfo extends COSmartCardItem
{
    PermitNumber: string;
    Description: string;
    PropertyAddress: Address;
    Status: string;
    ExpirationDate: string;
    ExpirationDateShort: string;
}
